import {
  SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_MOVE_IN_DATE,
  SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_LEASE_TERM,
  SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_SSN,
  SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_CREDIT_SCORE,
  SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_DEPENDENTS,
  SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_BACKGROUND_CHECK,
  SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_INCOME_VERIFICATION,
  SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_PETS,
  SR_APPLICATION_ASSEMBLY_LINE_STATUS_QUALIFIED,
  getNextStatus,
  getLatestStatus,
} from 'common/applicationAssemblyLineConstants';

import { HOUSEHOLD_APPLICATION_CATEGORY_GUARANTOR_APPLICATION } from 'common/householdConstants';

/* eslint-disable max-len */
import SrApplicationAssemblyLineStepMoveInDate from 'client/components/SrApplicationAssemblyLine/SrApplicationAssemblyLineStepMoveInDate/SrApplicationAssemblyLineStepMoveInDate';
import SrApplicationAssemblyLineStepLeaseTerm from 'client/components/SrApplicationAssemblyLine/SrApplicationAssemblyLineStepLeaseTerm/SrApplicationAssemblyLineStepLeaseTerm';
import SrApplicationAssemblyLineStepSSN from 'client/components/SrApplicationAssemblyLine/SrApplicationAssemblyLineStepSSN/SrApplicationAssemblyLineStepSSN';
import SrApplicationAssemblyLineStepCreditScore from 'client/components/SrApplicationAssemblyLine/SrApplicationAssemblyLineStepCreditScore/SrApplicationAssemblyLineStepCreditScore';
import SrApplicationAssemblyLineStepDependents from 'client/components/SrApplicationAssemblyLine/SrApplicationAssemblyLineStepDependents/SrApplicationAssemblyLineStepDependents';
import SrApplicationAssemblyLineStepBackgroundCheck from 'client/components/SrApplicationAssemblyLine/SrApplicationAssemblyLineStepBackgroundCheck/SrApplicationAssemblyLineStepBackgroundCheck';
import SrApplicationAssemblyLineStepIncomeVerification from 'client/components/SrApplicationAssemblyLine/SrApplicationAssemblyLineStepIncomeVerification/SrApplicationAssemblyLineStepIncomeVerification';
import SrApplicationAssemblyLineStepPets from 'client/components/SrApplicationAssemblyLine/SrApplicationAssemblyLineStepPets/SrApplicationAssemblyLineStepPets';

export const SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_TO_COMPONENT_MAPPING = {
  [SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_MOVE_IN_DATE]: SrApplicationAssemblyLineStepMoveInDate,
  [SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_LEASE_TERM]: SrApplicationAssemblyLineStepLeaseTerm,
  [SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_SSN]: SrApplicationAssemblyLineStepSSN,
  [SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_CREDIT_SCORE]: SrApplicationAssemblyLineStepCreditScore,
  [SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_DEPENDENTS]: SrApplicationAssemblyLineStepDependents,
  [SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_BACKGROUND_CHECK]: SrApplicationAssemblyLineStepBackgroundCheck,
  [SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_INCOME_VERIFICATION]: SrApplicationAssemblyLineStepIncomeVerification,
  [SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_PETS]: SrApplicationAssemblyLineStepPets,
};

export const SR_APPLICATION_ASSEMBLY_LINE_STEP_FIELD_ID_TO_LEGACY_FIELD = {
  [SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_MOVE_IN_DATE]: 'moveInDate',
  [SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_LEASE_TERM]: 'leaseTerm',
  [SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_SSN]: 'ssn',
  [SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_DEPENDENTS]: 'childrenCount',
  [SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_INCOME_VERIFICATION]: 'monthlyIncome',
  [SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_PETS]: 'petCount',
};
export const SR_APPLICATION_ASSEMBLY_LINE_LEGACY_FIELD_EDIT_MODE = {
  [SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_MOVE_IN_DATE]: 'field',
  [SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_LEASE_TERM]: 'field',
  [SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_SSN]: 'field',
  [SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_DEPENDENTS]: '',
  [SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_INCOME_VERIFICATION]: '',
  [SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_PETS]: '',
};

export const SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_TO_OVERRIDE_FIELD_MAPPING = {
  [SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_MOVE_IN_DATE]: 'statusOverrideMoveInDate',
  [SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_LEASE_TERM]: 'statusOverrideLeaseTerm',
  [SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_SSN]: 'statusOverrideSsn',
  [SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_CREDIT_SCORE]: 'statusOverrideCreditScore',
  [SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_DEPENDENTS]: 'statusOverrideDependents',
  [SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_BACKGROUND_CHECK]: 'statusOverrideBackgroundCheck',
  [SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_INCOME_VERIFICATION]: 'statusOverrideIncomeVerification',
  [SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_PETS]: 'statusOverridePetInfo',
};

export const SR_APPLICATION_ASSEMBLY_LINE_LEAD_STEP_IDS = Object.keys(
  SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_TO_COMPONENT_MAPPING,
);
export const SR_APPLICATION_ASSEMBLY_LINE_GUARANTOR_STEP_IDS = [
  SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_SSN,
  SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_CREDIT_SCORE,
  SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_BACKGROUND_CHECK,
  SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_INCOME_VERIFICATION,
];
export const SR_APPLICATION_ASSEMBLY_LINE_ROOMMATE_STEP_IDS = [
  SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_SSN,
  SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_CREDIT_SCORE,
  SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_DEPENDENTS,
  SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_BACKGROUND_CHECK,
  SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_INCOME_VERIFICATION,
];
/* eslint-enable max-len */

export const getStepIdsByHouseholdCategory = ({ category, isLeadRenter }) => {
  return category === HOUSEHOLD_APPLICATION_CATEGORY_GUARANTOR_APPLICATION
    ? SR_APPLICATION_ASSEMBLY_LINE_GUARANTOR_STEP_IDS
    : isLeadRenter
    ? SR_APPLICATION_ASSEMBLY_LINE_LEAD_STEP_IDS
    : SR_APPLICATION_ASSEMBLY_LINE_ROOMMATE_STEP_IDS;
};

export const getStepStatuses = ({ assemblyLine, householdApplication }) => {
  const assemblyLineApplication = householdApplication.assemblyLineApplication || {};
  const stepIds = getStepIdsByHouseholdCategory({
    category: householdApplication.category,
    isLeadRenter: householdApplication.userId === assemblyLine.leadRenterId,
  });

  return stepIds.map((stepId) => ({
    stepId,
    stepTitle: SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_TO_COMPONENT_MAPPING[stepId].stepTitle,
    status:
      assemblyLineApplication[
        SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_TO_OVERRIDE_FIELD_MAPPING[stepId]
      ] ||
      SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_TO_COMPONENT_MAPPING[stepId].getStatus({
        assemblyLine,
        householdApplication,
      }),
    isEditable: SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_TO_COMPONENT_MAPPING[stepId].isEditable
      ? SR_APPLICATION_ASSEMBLY_LINE_STEP_ID_TO_COMPONENT_MAPPING[stepId].isEditable({
          assemblyLine,
          householdApplication,
        })
      : true,
  }));
};

/**
 * Gets the next step ID to be worked on. Not qualified,
 * pending and completed steps are not counted.
 *
 * @param  {Object}  assemblyLine          The assembly line data object.
 * @param  {Object}  householdApplication  The currently focused application.
 * @return {string}                        The next status.
 */
export const getNextStepId = ({ assemblyLine, householdApplication }) => {
  const stepStatuses = getStepStatuses({ assemblyLine, householdApplication });
  const nextStatus = getNextStatus(stepStatuses.map(({ status }) => status));
  for (const stepStatus of stepStatuses) {
    if (stepStatus.status === nextStatus) {
      return stepStatus.stepId;
    }
  }
};

export const getAssemblyLineStatus = ({ assemblyLine }) => {
  const stepsByRenters = assemblyLine.renters.map((user, index) => {
    const householdApplication = assemblyLine.householdApplications.find(({ userId }) => {
      return userId === user.id;
    });

    const stepStatuses = getStepStatuses({
      assemblyLine,
      householdApplication,
    });

    const stepsCompleted = stepStatuses.filter(({ status }) => {
      return status === SR_APPLICATION_ASSEMBLY_LINE_STATUS_QUALIFIED;
    });

    return {
      renterId: user.id,
      renterName:
        `${householdApplication.firstName} ${householdApplication.lastName}`.trim() || user.name,
      renterPhone: user.phone,
      applicantType: 'renter',
      applicantTitle: index === 0 ? 'Lead 1' : `Renter ${index + 1}`,
      renterIsLead: user.id === assemblyLine.leadRenterId,
      applicationId: householdApplication.id,
      applicationStatus: householdApplication.status,
      status: getLatestStatus(stepStatuses.map(({ status }) => status)),
      progressPercent: stepsCompleted.length / stepStatuses.length,
      nextStepId: getNextStepId({ assemblyLine, householdApplication }),
      stepStatuses,
    };
  });

  const stepsByGuarantors = assemblyLine.guarantors.map((user, index) => {
    const householdApplication = assemblyLine.guarantorApplications.find(({ userId }) => {
      return userId === user.id;
    });

    const stepStatuses = getStepStatuses({
      assemblyLine,
      householdApplication,
    });

    const stepsCompleted = stepStatuses.filter(({ status }) => {
      return status === SR_APPLICATION_ASSEMBLY_LINE_STATUS_QUALIFIED;
    });

    return {
      renterId: user.id,
      renterName:
        `${householdApplication.firstName} ${householdApplication.lastName}`.trim() || user.name,
      renterPhone: user.phone,
      applicantType: 'guarantor',
      applicantTitle: `Guarantor ${assemblyLine.renters.length + index + 1}`,
      renterIsLead: false,
      applicationId: householdApplication.id,
      applicationStatus: householdApplication.status,
      status: getLatestStatus(stepStatuses.map(({ status }) => status)),
      progressPercent: stepsCompleted.length / stepStatuses.length,
      nextStepId: getNextStepId({ assemblyLine, householdApplication }),
      stepStatuses,
    };
  });

  const stepsByApplicants = [...stepsByRenters, ...stepsByGuarantors];

  return {
    status: getLatestStatus(stepsByApplicants.map(({ status }) => status)),
    progressPercent:
      stepsByApplicants.reduce((memo, step) => memo + step.progressPercent, 0) /
      stepsByApplicants.length,
    stepsByApplicants,
  };
};
